import { render, staticRenderFns } from "./CarouselArrow.vue?vue&type=template&id=0fa14ce8&scoped=true"
import script from "./CarouselArrow.vue?vue&type=script&lang=js"
export * from "./CarouselArrow.vue?vue&type=script&lang=js"
import style0 from "./CarouselArrow.vue?vue&type=style&index=0&id=0fa14ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa14ce8",
  null
  
)

export default component.exports